import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crosshair, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "../lib/api";

const INCLUDED = ["Live desktop + mobile capture", "DOM, style & network forensics", "Framework fingerprinting", "8-tab intelligence report", "Reconstruction blueprint", "PDF · JSON · Markdown exports"];

export const InvestigationEntry = ({ credits, onBuyMore }) => {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const target = url.trim() ? (url.trim().startsWith("http") ? url.trim() : `https://${url.trim()}`) : null;
  const start = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await http.post("/investigations", { url: target });
      nav(`/report/${data.token}`);
    } catch (err) { toast.error(errMsg(err)); setBusy(false); }
  };
  return (
    <section data-testid="investigation-entry" className="anim-rise">
      <p className="rea-label text-[#d4af37]">// access granted</p>
      <h1 className="font-hero mt-3 text-3xl leading-[1.1] sm:text-4xl lg:text-5xl">Your R.E.A. Intelligence Access Is Ready.</h1>
      <div className="mt-6 flex flex-wrap items-center gap-3">
        <span data-testid="remaining-credits" className="border border-[#d4af37]/50 px-3 py-1.5 font-mono text-sm text-[#d4af37]">{credits} investigation credit{credits === 1 ? "" : "s"} remaining</span>
        <button data-testid="buy-more-btn" onClick={onBuyMore} className="font-mono text-xs uppercase tracking-widest text-neutral-500 underline-offset-4 hover:text-white hover:underline">Buy more</button>
      </div>
      <form onSubmit={start} className="rea-panel rea-brackets rea-glow mt-10 p-5 sm:p-7">
        <label htmlFor="target" className="text-sm text-neutral-300">Enter the website URL you want R.E.A. to investigate.</label>
        <div className="mt-3 flex flex-col gap-3 sm:flex-row">
          <input id="target" data-testid="target-url-input" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://example.com" autoComplete="off"
            className="flex-1 border border-[#333] bg-[#070707] px-4 py-4 font-mono text-sm outline-none transition-colors focus:border-red-600" />
          <button data-testid="start-investigation-btn" disabled={!target || busy || credits < 1}
            className="flex items-center justify-center gap-2 bg-red-700 px-7 py-4 font-mono text-xs font-bold uppercase tracking-[0.2em] transition-colors hover:bg-red-600 disabled:opacity-40">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Crosshair className="h-4 w-4" />} Start Investigation
          </button>
        </div>
        {target && <p data-testid="selected-target" className="mt-3 font-mono text-xs text-neutral-500">Target locked: <span className="text-red-400">{target}</span> · uses 1 credit</p>}
      </form>
      <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-2 sm:grid-cols-3">
        {INCLUDED.map((x, i) => <p key={x} className="font-mono text-xs text-neutral-400"><span className="text-red-600">{String(i + 1).padStart(2, "0")}</span> {x}</p>)}
      </div>
      <p className="mt-6 text-xs text-neutral-600">Investigations take roughly 2–4 minutes. If the target cannot be reached, your credit is refunded automatically.</p>
    </section>
  );
};
